const deleteServices = {
  toastr: 'Serviço deletado'
};

export default deleteServices;
